import { render, staticRenderFns } from "./ecHexaButton.vue?vue&type=template&id=78619b71&lang=pug&"
import script from "./ecHexaButton.vue?vue&type=script&lang=ts&"
export * from "./ecHexaButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VBtn: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VBtn/VBtn.js').default})
